import $foreign from "./foreign.cjs";
var unfoldr1ArrayImpl = $foreign.unfoldr1ArrayImpl;
export { unfoldr1ArrayImpl };
